import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import Checkbox from '@mui/material/Checkbox';
import Stack from '@mui/material/Stack';
import TextField from '@mui/material/TextField';
import Typography from '@mui/material/Typography';
import { StaticImage } from 'gatsby-plugin-image';
import React from 'react';
import { TypeOcrH6 } from './Types';

async function sendMessage(
  email: string,
  module: boolean,
  plugin: boolean,
  pedal: boolean,
  all: boolean
) {
  if (!window) {
    return;
  }

  if (all) module = plugin = pedal = true;

  const jsonBlob = JSON.stringify({
    pedal: pedal,
    email: email,
    module: module,
    plugin: plugin,
    magic: 826670146,
  });

  const response = await fetch(window.location.origin + '/subscribe', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    body: jsonBlob,
  });
  console.log(response, await response.text());
}

function canSendMessage(
  email: string,
  module: boolean,
  plugin: boolean,
  pedal: boolean,
  all: boolean
) {
  if (email.length <= 5 || !email.includes('@') || !email.includes('.')) {
    return false;
  }

  return module || plugin || pedal || all;
}

export default function Newsletter() {
  const [email, setEmail] = React.useState('');
  const [buttonMessage, setButtonMessage] = React.useState('Sign me up!');
  const [module, setModule] = React.useState(false);
  const [plugin, setPlugin] = React.useState(false);
  const [pedal, setPedal] = React.useState(false);
  const [all, setAll] = React.useState(true);
  return (
    <>
      <Box width='100%' bgcolor='success.main'>
        <Stack
          direction={{ xs: 'column', sm: 'column', md: 'row', lg: 'row' }}
          justifyContent='center'
          alignItems='center'
        >
          <Box sx={{ m: 3, fit: 'scale-down' }}>
            <StaticImage
              height={150}
              src='./shape.png'
              alt='sign up for the newsletter. This is a placeholder shape.'
            />
          </Box>
          <Stack
            alignItems='center'
            justifyContent='center'
            direction={{ xs: 'column', sm: 'column', md: 'row', lg: 'row' }}
          >
            <Stack sx={{ mx: 3, mt: 3, mb: 3, width: '60%' }}>
              <TypeOcrH6 align='center'>Never Miss a Beat</TypeOcrH6>
              <Typography align='center' mb={3}>
                Get first dibs on discounts, presales, and all NE news. Your
                email address will never be shared, sold, or used for nefarious
                purposes.
              </Typography>
              <TextField
                id='1234566'
                label='Email'
                sx={{ width: '80%', mx: 5, mb: 3 }}
                style={{ borderRadius: 0 }}
                onChange={(e: any) => setEmail(e.target.value)}
                value={email}
              ></TextField>
            </Stack>
            <Stack>
              <Stack direction='row'>
                <Checkbox
                  checked={module}
                  onChange={(e) => {
                    setModule(!module);
                  }}
                />
                <Typography mt={1}>Module News</Typography>
              </Stack>
              <Stack direction='row'>
                <Checkbox
                  checked={plugin}
                  onChange={(e) => {
                    setPlugin(!plugin);
                  }}
                />
                <Typography mt={1}>Plugin News</Typography>
              </Stack>
              <Stack direction='row'>
                <Checkbox
                  checked={pedal}
                  onChange={(e) => {
                    setPedal(!pedal);
                  }}
                />
                <Typography mt={1}>Pedal News</Typography>
              </Stack>
              <Stack direction='row'>
                <Checkbox
                  checked={all}
                  onChange={(e) => {
                    setAll(!all);
                  }}
                />
                <Typography mt={1}>All the News</Typography>
              </Stack>
              <Button
                disabled={!canSendMessage(email, module, plugin, pedal, all)}
                color='info'
                variant='contained'
                style={{ borderRadius: 0 }}
                sx={{ mr: 5, mt: 2, mb: 2, width: '15rem' }}
                onClick={async () => {
                  setButtonMessage("#workin' on it");
                  await sendMessage(email, module, plugin, pedal, all);
                  setButtonMessage('Thanks for signing up!');
                }}
              >
                {buttonMessage}
              </Button>
            </Stack>
          </Stack>
        </Stack>
      </Box>
    </>
  );
}
